<template>
    <div class="vx-row">
        <div class="w-full vx-col">
            <vx-card :title="'Manage Raw Material Settings'" class="">
                <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                    <form @submit.prevent="handleSubmit(onClickSave)">
                        <div class="vx-row">

                            <div class="w-1/2 vx-col mb-4" v-for="(item, index) in form" :key="index">
                                <small>{{ item.label }}</small>
                                <ValidationProvider :name="`${index}-${item.name}`" rules="required" v-slot="{ errors }"
                                    :vid="`${index}-${item.name}`"  v-if="item.type === 'text' || item.type === 'integer'">
                                    <vs-input
                                        v-model="item.value" :type="item.type" class="w-full" :name="`${index}-${item.name}`"></vs-input>
                                    <span class="text-danger text-sm">{{ errors[0] }}</span>
                                </ValidationProvider>

                                <YesNoToggle v-if="item.type === 'boolean'" v-model="item.value" />

                            </div>

                        </div>
                        <div class="flex flex-wrap items-center justify-end">
                            <vs-button button="submit" class="ml-auto mt-2" v-can="'edit-staff-leaves'">
                                Save Changes
                            </vs-button>
                        </div>
                    </form>
                </ValidationObserver>
            </vx-card>
        </div>
    </div>
</template>

<script>
import ErrorMessages from '@/mixins/ErrorMessages'
import YesNoToggle from "@/components/yes-no-toggle/YesNoToggle.vue"

import { RepositoryFactory } from '@/repository/RepositoryFactory';
const RmSettingsRepository = RepositoryFactory.get('rm_settings');

export default {
    name: "ManageRawMaterialSettings",
    data() {
        return {
            form: []
        }
    },
    components: {
        YesNoToggle
    },
    async mounted() {
        await this.fetchData()
    },
    mixins: [ErrorMessages],
    methods: {
        async fetchData() {
            this.$vs.loading();
            try {
                const { data } = (await RmSettingsRepository.getRmSettings()).data
                this.form = []

                const keys = Object.keys(data);
                for (const key of keys) {
                    data[key].elements.forEach((x) => {
                        this.form.push({ name: x.name, value: x.value, label: x.label, type: x.type })
                    })
                }

            } catch (error) {
                this.convertAndNotifyError(error);
            } finally {
                this.$vs.loading.close()
            }
        },
        async onClickSave() {
            try {
                let payload = this.form.reduce((obj, item) => {
                    obj[item.name] = item.value;
                    return obj;
                }, {});
                await RmSettingsRepository.updateRmSettings(payload);
                await this.fetchData()
            } catch (error) {

            }
        }
    }
}
</script>
<style lang="">

</style>